// extracted by mini-css-extract-plugin
export default {"button":"Pj-z","reviewSort":"Qj-z"};